<script lang="ts">
  import { onMount } from 'svelte';

  export let url: string;
  export let model: string;
  export let value: string | null = '';
  export let placeholder = '';
  export let multiline = false;
  export let maxlength: number | undefined = undefined;

  let text = value ?? '';
  let lastSaved = text;
  let timer: ReturnType<typeof setTimeout>;
  let textarea: HTMLTextAreaElement;

  // Grows the question box to fit its text.
  function fitHeight() {
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  // Saves a second after typing stops.
  function handleInput() {
    fitHeight();
    clearTimeout(timer);
    timer = setTimeout(save, 1000);
  }

  let pending = Promise.resolve();

  // Saves one at a time, so an older save can't land after a newer one.
  function save() {
    clearTimeout(timer);
    pending = pending.then(send, send);
  }

  // Sends the text if it changed since the last save.
  async function send() {
    if (text === lastSaved) return;

    const sending = text;
    const response = await fetch(url, {
      method: 'PATCH',
      credentials: 'same-origin',
      // Lets the save finish if the owner leaves the page right after typing.
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      },
      body: JSON.stringify({ [model]: { content: sending } }),
    });
    if (response.ok) lastSaved = sending;
  }

  onMount(fitHeight);
</script>

<div class="flex-1 min-w-0">
  {#if multiline}
    <textarea
      bind:this={textarea}
      bind:value={text}
      {placeholder}
      {maxlength}
      rows="1"
      class="block w-full resize-none overflow-hidden rounded-lg border border-neutral-200 bg-white px-3 py-2 text-base leading-[26px] placeholder:text-neutral-400"
      on:input={handleInput}
      on:blur={save}
    />
  {:else}
    <input
      type="text"
      bind:value={text}
      {placeholder}
      {maxlength}
      class="block w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-base leading-[26px] placeholder:text-neutral-400"
      on:input={handleInput}
      on:blur={save}
    />
  {/if}
</div>
